class GridViewFieldsUtils {
	getFieldName(item) {
		if (item == null) return null;
		if (item.DataField == null) return null;
		if (item.DataField.EntityId == null) return null;
		if (
			item.LinkFieldId != null &&
			item.LinkField == null &&
			item.LinkField.Entity == null
		)
			return null;
		if (item.LinkFieldId) {
			return (
				item.LinkField.EntityName +
				'_' +
				item.LinkField.FieldName +
				'_' +
				item.DataField.EntityName +
				'_' +
				item.DataField.FieldName
			);
		}
		if (item.ReferenceListTypeId != null && item.ReferenceListType == null)
			return null;
		if (item.ReferenceListTypeId) {
			return (
				item.DataField.EntityName +
				'_' +
				item.DataField.FieldName +
				'_' +
				'Reference'
			);
		}
		return item.DataField.EntityName + '_' + item.DataField.FieldName;
	}
}
const gridViewFieldsUtils = new GridViewFieldsUtils();
export default gridViewFieldsUtils;
